import React from "react";
import { useNavigate } from "react-router-dom";
import "./OutsideServingHours.css";
import { formatServingTime } from "../../../common/servingHours";

// Shown in place of a request form when the guest taps a service outside the
// hours the hotel accepts requests in.
export default function OutsideServingHours({ hotel, bookingId }) {

    const navigate = useNavigate();

    const from = formatServingTime(hotel?.service_start_time);
    const to = formatServingTime(hotel?.service_end_time);

    return (
        <div className="serving-hours">
            <div className="serving-hours-card">
                <div className="serving-hours-icon">🌙</div>
                <h3>We're outside serving hours</h3>
                <p>
                    {from && to
                        ? `${hotel?.name || "The hotel"} takes requests on the app between ${from} and ${to}.`
                        : `${hotel?.name || "The hotel"} is not taking requests on the app right now.`}
                </p>
                <p className="serving-hours-note">
                    Need something now? Please call the reception directly and
                    the team will help you.
                </p>

                <button
                    className="serving-hours-back"
                    onClick={() => navigate(`/bookings/${bookingId}`)}
                >
                    Back to my stay
                </button>
            </div>
        </div>
    );
}
